export const inTeams = (): boolean => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export const isB2B = process.env.REACT_APP_AD_INSTANCE?.toString() === "B2B";
